import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { actions } from "../../actions";
import {
  getUntilDate,
  getFromDate,
  getNightCount,
  getRoomsCount,
} from "../../../search/reducer/selectors";
import {
  getHotelShopRoomInfoProducts,
  getHotelShopCallState,
  getHotelShopSelectedLodging,
  getHotelShopChosenProduct,
  getHotelShopChosenRoomInfo,
  hotelShopProgressSelector,
  getCheapestProduct,
} from "../../reducer/selectors";
import { MobileHotelShopRoomTypePickerPanel } from "./component";
import { HotelShopCallState } from "../../reducer/state";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../rewards/reducer";
import { hasSelectedRefundableRoomSelector } from "../../../ancillary/reducer";

const mapStateToProps = (state: IStoreState) => {
  const roomsCount = getRoomsCount(state);
  const checkinDate = getFromDate(state);
  const checkoutDate = getUntilDate(state);
  const chosenRoomInfo = getHotelShopChosenRoomInfo(state);
  const chosenProduct = getHotelShopChosenProduct(state);
  const selectedLodging = getHotelShopSelectedLodging(state);
  const nightCount = getNightCount(state);
  const rewardsKey =
    getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined;
  const roomInfoProducts = getHotelShopRoomInfoProducts(state);
  const isHotelShopLoading =
    getHotelShopCallState(state) === HotelShopCallState.InProcess;
  const hotelShopStep = hotelShopProgressSelector(state);
  const hasSelectedRefundableRoom = hasSelectedRefundableRoomSelector(state);

  const cheapestProduct = getCheapestProduct(state);

  return {
    checkinDate,
    checkoutDate,
    chosenRoomInfo,
    chosenProduct,
    selectedLodging,
    nightCount,
    rewardsKey,
    roomInfoProducts,
    isHotelShopLoading,
    hotelShopStep,
    roomsCount,
    cheapestProduct,
    hasSelectedRefundableRoom,
  };
};

const mapDispatchToProps = {
  selectRoomType: actions.selectRoomType,
  fetchHotelShop: actions.fetchHotelShop,
  setHotelShopProgress: actions.setHotelShopProgress,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelShopRoomTypePickerPanelConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelShopRoomTypePickerPanel = withRouter(
  connector(MobileHotelShopRoomTypePickerPanel)
);
